import axios from '@/libs/api.request'

export const getSecurityIPList = (page, limit, key) => {
  return axios.request({
    url: '/v1/system/security-ip/',
    method: 'get',
    params: {
      page,
      limit,
      key
    }
  })
}

export const operationSecurityIP = (data, meth) => {
  return axios.request({
    url: '/v1/system/security-ip/',
    method: meth,
    data
  })
}